import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const OrderHistory = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await api.get('/orders');
      setOrders(res.data.orders);
    } catch (err) {
      console.error('Failed to fetch orders', err);
    } finally {
      setLoading(false);
    }
  };

  const viewOrderDetails = async (orderId) => {
    try {
      const res = await api.get(`/orders/details?id=${orderId}`);
      setSelectedOrder(res.data.order);
    } catch (err) {
      console.error('Failed to fetch order details', err);
    }
  };

  const closeModal = () => setSelectedOrder(null);

  if (loading) return <div className="loading">Loading orders...</div>;

  return (
    <div className="order-history-container">
      <h2>Order History</h2>
      {orders.length === 0 ? (
        <p>No orders yet.</p>
      ) : (
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Total</th>
              <th>Status</th>
              <th>Items</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <tr key={order.id}>
                <td>#{order.id}</td>
                <td>{new Date(order.order_date).toLocaleDateString()}</td>
                <td>${order.total_amount}</td>
                <td className={`status-${order.payment_status}`}>{order.payment_status}</td>
                <td>{order.item_count}</td>
                <td>
                  <button onClick={() => viewOrderDetails(order.id)} className="view-btn">
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selectedOrder && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Order #{selectedOrder.id}</h3>
            <p>Date: {new Date(selectedOrder.order_date).toLocaleString()}</p>
            <p>Total: ${selectedOrder.total_amount}</p>
            <p>Status: {selectedOrder.payment_status}</p>
            <h4>Items</h4>
            <table className="order-items-table">
              <thead>
                <tr><th>Lead ID</th><th>Price</th><th>Type</th></tr>
              </thead>
              <tbody>
                {selectedOrder.items.map(item => (
                  <tr key={item.id}>
                    <td>#{item.lead_id}</td>
                    <td>${item.price}</td>
                    <td>{item.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button onClick={closeModal} className="close-modal">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderHistory;